import type {
  ColumnsSourceItem,
  MapColumnsResult,
} from '@/shared/model/types/mapColumnsArrays';

export const mapColumnsArrays = (
  el: Pick<ColumnsSourceItem, 'id' | 'name' | 'slug'>,
  link: string,
  subitemsName: string,
  isHasIcon = false,
  isShowSubitems = false,
  classMod = '',
): MapColumnsResult => {
  const subitemsValue = Reflect.get(el, subitemsName);

  return {
    id: el.id,
    name: el.name,
    slug: el.slug,
    iconName: isHasIcon ? String(el.slug) : '',
    classMod,
    link,
    subitems: isShowSubitems && Array.isArray(subitemsValue) ? subitemsValue : '',
  };
};
